module.exports = __webpack_public_path__ + "img/47.f5b3bd18.jpg";